import PropTypes from 'prop-types';
import Spinner from '../common/Spinner';
import useModalClose from '../../hooks/useModalClose';
import { useState, useEffect } from 'react';
import { getAllAssignments } from '../../services/vehicleService';
import { formatDate } from '../../helpers/stringHelpers';

const AssignmentDetailModal = ({ isOpen, onClose, assignmentId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [assignment, setAssignment] = useState(null);

  useModalClose(isOpen, onClose);

  useEffect(() => {
    if (isOpen && assignmentId) {
      fetchAssignmentData();
    }
  }, [isOpen, assignmentId]);

  const fetchAssignmentData = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const data = await getAllAssignments({ id: assignmentId });

      if (data.status === 200 && data.assignments && data.assignments.length > 0) {
        setAssignment(data.assignments[0]);
      } else {
        setError('Görevlendirme bilgileri alınamadı.');
      }
    } catch (error) {
      console.error('Failed to fetch assignment:', error);
      setError('Görevlendirme bilgileri alınamadı.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content assignment-detail-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Görevlendirme Detayları</h3>
        </div>

        {isLoading ? (
          <div className="loading-state">
            <Spinner size="large" />
            <h3>Görevlendirme bilgileri yükleniyor...</h3>
          </div>
        ) : error ? (
          <div className="error-state">
            <p className="error-message">{error}</p>
            <button type="button" onClick={onClose} className="close-button">
              Kapat
            </button>
          </div>
        ) : assignment ? (
          <div className="modal-body">
            <div className="assignment-header">
              <h4 className="assignment-date">{formatDate(assignment.assignmentDate)}</h4>
              <h4 className="assignment-plate">{assignment.numberPlate}</h4>
            </div>
            
            <div className="assignment-location">
              <h5 className="section-title">Görevlendirme Yeri</h5>
              <p className="location-text">
                <span>{assignment.district}</span><span>{assignment.neighbourHood} Mahallesi</span>
              </p>
            </div>

            {assignment.scaleInformation && (
              <div className="assignment-scale">
                <h5 className="section-title">Kantar Bilgisi</h5>
                <p className="scale-text">{assignment.scaleInformation} kg</p>
              </div>
            )}
            
            <div className="assignment-users">
              <h5 className="section-title">Görevli Kişiler</h5>
              <div className="users-list">
                {assignment.users && assignment.users.length > 0 ? (
                  assignment.users.map((user, index) => (
                    <div key={user.id} className="user-item">
                      <p className="user-name">{user.ad}</p>
                      <p className="user-tc">{user.tc}</p>
                    </div>
                  ))
                ) : (
                  <p className="no-users">Görevli kişi bulunmamaktadır.</p>
                )}
              </div>
            </div>

            <div className="modal-actions">
              <button type="button" onClick={onClose} className="close-button">
                Kapat
              </button>
            </div>
          </div>
        ) : (
          <div className="error-state">
            <p>Görevlendirme bulunamadı.</p>
            <button type="button" onClick={onClose} className="close-button">
              Kapat
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

AssignmentDetailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  assignmentId: PropTypes.string
};

export default AssignmentDetailModal; 